<template>
  <AppBtn class="bracket-header-btn" v-on="$listeners" v-bind="$attrs">
    <slot />
  </AppBtn>
</template>

<script>
export default {
  name: "BracketHeaderBtn"
};
</script>

<style lang="scss">
.bracket-header-btn {
  width: 45px;
  height: 45px;

  &:not(:last-child) {
    margin-right: 10px;
  }
}
</style>
